// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"08b5469a","164":"2f05d2e5","707":"0857ca29"}[chunkId] + ".chunk.js";
};